import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ToasterService } from './service';
import { ToasterContainerComponent } from './toaster-container';
import { ToasterPresenter } from './toaster-presenter';

@NgModule({
    declarations: [ToasterContainerComponent, ToasterPresenter],
    imports: [CommonModule, ToastModule],
    exports: [ToasterContainerComponent, ToasterPresenter],
    providers: [ToasterService]
})
export class EFToasterModule {}
